import { useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";

const Laboratory = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const isActive = (id) => (activeTab === id ? "active" : "");
  const showPane = (id) =>
    `tab-pane fade ${activeTab === id ? "active show" : ""}`;

  return (
    <>
      <Breadcrumb
        breadtitle="Laboratory"
        breadmid="Facilities"
        breadend="Laboratory"
      />
      <div className="innerpage library_blk">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-6 col-md-12">
              <div className="content">
                <ul className="list-view">
                  <li>
                    Students will follow the Guidance given by the teacher in
                    the Computer and Science Laboratory. They should take care
                    in handling the equipment and chemicals.
                  </li>
                  <li>
                    Damaged equipment or breakage will be replaced by the
                    student concerned. All dues must be cleared by the students
                    before assessments.
                  </li>
                  <li>
                    No Practical classes will be skipped by the students without
                    the permission of the Principal.
                  </li>
                  <li>
                    They should follow rules of safety while using chemicals and
                    seek the guidance of the teacher in charge.
                  </li>
                  <li>
                    No student will enter the Laboratory except during the
                    practical classes.
                  </li>
                  <li>No equipment will be carried out of the laboratory.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="row">
            <div className="col-md-12">
              <ul className="nav nav-pills" id="labTabs" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab1")}`}
                    role="tab"
                    aria-selected={activeTab === "tab1"}
                    aria-controls="tabContent1"
                    id="tab1"
                    onClick={() => setActiveTab("tab1")}
                  >
                    Computer
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab2")}`}
                    role="tab"
                    aria-selected={activeTab === "tab2"}
                    aria-controls="tabContent2"
                    id="tab2"
                    onClick={() => setActiveTab("tab2")}
                  >
                    Computer (Primary)
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab3")}`}
                    role="tab"
                    aria-selected={activeTab === "tab3"}
                    aria-controls="tabContent3"
                    id="tab3"
                    onClick={() => setActiveTab("tab3")}
                  >
                    Chemistry
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab4")}`}
                    role="tab"
                    aria-selected={activeTab === "tab4"}
                    aria-controls="tabContent4"
                    id="tab4"
                    onClick={() => setActiveTab("tab4")}
                  >
                    Physics
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${isActive("tab5")}`}
                    role="tab"
                    aria-selected={activeTab === "tab5"}
                    aria-controls="tabContent5"
                    id="tab5"
                    onClick={() => setActiveTab("tab5")}
                  >
                    Biology
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Tab panes */}
          <div className="tab-content mt-3">
            <div
              className={showPane("tab1")}
              id="tabContent1"
              role="tabpanel"
              aria-labelledby="tab1"
            >
              <h5 className="tabhead">
                <span>Computer Lab</span>
              </h5>
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clab5.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clab5.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clab6.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clab6.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clab7.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clab7.jpg"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={showPane("tab2")}
              id="tabContent2"
              role="tabpanel"
              aria-labelledby="tab2"
            >
              <h5 className="tabhead">
                <span>Computer Lab (Primary)</span>
              </h5>
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp1.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp1.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp2.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp2.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp3.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp3.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp4.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/clabp4.jpg"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={showPane("tab3")}
              id="tabContent3"
              role="tabpanel"
              aria-labelledby="tab3"
            >
              <h5 className="tabhead">
                <span>Chemistry Lab</span>
              </h5>
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/chem1.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/chem1.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/chem2.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/chem2.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/chem3.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/chem3.jpg"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={showPane("tab4")}
              id="tabContent4"
              role="tabpanel"
              aria-labelledby="tab4"
            >
              <h5 className="tabhead">
                <span>Physics Lab</span>
              </h5>
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Phy1.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Phy1.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Phy2.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Phy2.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Phy3.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/Phy3.jpg"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={showPane("tab5")}
              id="tabContent5"
              role="tabpanel"
              aria-labelledby="tab5"
            >
              <h5 className="tabhead">
                <span>Biology Lab</span>
              </h5>
              <div className="row">
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/bio1.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/bio1.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/bio2.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/bio2.jpg"
                      />
                    </a>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-12">
                  <div className="img-box">
                    <a
                      data-magnify="gallery"
                      data-group="a"
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/bio3.jpg"
                    >
                      <img
                        alt="Canossa School Lucknow"
                        className="img-thumbnail"
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/bio3.jpg"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom images */}
        </div>
      </div>
    </>
  );
};

export default Laboratory;
